/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

// project imports
import { BuyerList, BuyerEdit, TaxExemption, TaxExemptionPendingList } from 'features/components/base/buyer';

/**
 * routing for buyers components
 * 
 * @param props
 * 
 * @return routing for buyers components
 * 
**/

export class BuyerRouter extends Component {

    render() {
        return (
            <Switch>
                <Route exact path={`/buyer`} component={BuyerList} />
                <Route exact path={'/buyer/pending-tax-exemption'} component={TaxExemptionPendingList} />
                <Route exact path={`/buyer/edit/:buyerid`} component={BuyerEdit} />
                <Route exact path={`/buyer/edit/:buyerid/taxexemption`} component={TaxExemption} />

                <Redirect to="/home" />
            </Switch>
        );
    }
}